/**
 * lona-js re-export + helper over `@tento-core/dependency-graph`.
 *
 * The class + generic namespace helpers (visit, invalidationSet,
 * dependentsOnly, cycleCheck) live in core. This file re-exports
 * them unchanged. The SDK graph is a projection of the rows model graph,
 * copied without a second formula parser or name-binding policy.
 */

import { RowLocalId } from "@tento-lona/sheets";
import { type Sheet } from "@tento-lona/sheets/platform";
import { sheetWiring } from "@tento-lona/sheets/internal-sdk";
import {
  DependencyAspect,
  type DependencyEdge,
  DependencyGraph as CoreDependencyGraph,
  ReferenceType,
} from "@tento-core/dependency-graph";

export {
  DependencyAspect,
  ReferenceType,
  type DependencyEdge,
} from "@tento-core/dependency-graph";

export type DependencyGraph<T> = CoreDependencyGraph<T>;

/**
 * A dependency graph as a reader sees it: nodes and edges, no writes. What a
 * `SheetHandle` exposes as `graph` — the handle owns its edges and rebuilds
 * them itself (`rebuildGraph`). Defined once, in core.
 */
export type { DependencyGraphReads } from "@tento-core/dependency-graph";
export const DependencyGraph: typeof CoreDependencyGraph = CoreDependencyGraph;

/** Copy the rows model's resolved formula graph; the SDK owns no second name-binding algorithm. */
export function buildDependencyGraphFromModel(
  graph: CoreDependencyGraph<RowLocalId>,
  sheet: Sheet,
): void {
  sheetWiring(sheet).copyFormulaGraph(graph);
}
